export const TRANSFER_TYPES = Object.freeze({
  LINK: 'link',
  EMAIL: 'email',
});
